import clsx from 'classnames';
import React, {
  FC,
  useEffect,
  useState,
} from 'react';
import './index.scss';
import { TdsItem, Env, Version } from '../enum/tds';
import { TdsOverlay } from '../tds-overlay';
import {
  MORE_APPS,
  PC_NAVIGATION,
  MOBILE_NAVIGATION,
  NAVIGATION_URL,
} from './config';
import TdsLogo from './images/logo.svg';
import MenuIcon from './images/menu.svg';

interface TdsNavigationProps {
  className?: string;
  width?: number | string;
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  activeMenu: TdsItem;
  isProd: boolean;
  isMobile?: boolean;
  isWoa?: boolean;
}

export const TdsNavigation: FC<TdsNavigationProps> = (props) => {
  const {
    className,
    width = 1200,
    position = 'fixed',
    activeMenu,
    isProd,
    isMobile = false,
    isWoa = false,
  } = props;

  const [scroll, setScroll] = useState(window.scrollY !== 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const version = isWoa ? Version.WOA : Version.PRO;
  const env = isProd ? Env.PROD : Env.TEST;
  const homeUrl = NAVIGATION_URL[TdsItem.Home][version][env];

  const handleOpenUrl = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    url: string,
    key: TdsItem,
  ) => {
    e.preventDefault();
    if (!url) return;
    if (key === TdsItem.Hippy || key === TdsItem.Kuikly) {
      const source = {
        [TdsItem.Bugly]: 'bugly',
        [TdsItem.Shiply]: 'shiply',
        [TdsItem.Home]: 'tds',
        [TdsItem.Rightly]: 'rightly',
        [TdsItem.Hippy]: '',
        [TdsItem.Kuikly]: '',
        [TdsItem.More]: '',
        [TdsItem.Wuji]: 'wuji',
        [TdsItem.Fue]: '',
        [TdsItem.Raft]: '',
        [TdsItem.Mmkv]: '',
        [TdsItem.Wujie]: '',
        [TdsItem.WCDB]: '',
      }[activeMenu];
      window.open(`${url}?utm_source=${source}`, '_self');
    } else {
      window.open(url, '_self');
    }
  };

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY !== 0);

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const moreMenu = () => (
    <div className='tds-navigation-overlay-wrapper'>
      <div className='tds-navigation-overlay-title'>更多加盟产品</div>
      <div className='tds-navigation-overlay-grid'>
        {MORE_APPS.map((item, index) => (
          <div key={index}>
            <div className='tds-navigation-overlay-card' onClick={() => window.open(NAVIGATION_URL[item.key][version][env], '_self')}>
              <div className='tds-navigation-overlay-card-title-layout'>
                <img src={item.icon} className='tds-navigation-overlay-card-img' />
                <div className='tds-navigation-overlay-card-title'>
                  {item.title}
                </div>
              </div>
              <TdsOverlay
                component={item.desc}
                overlayClassName='tds-navigation-overlay-card-desc-overlay'
                placement='bottom'
              >
                <div className='tds-navigation-overlay-card-desc'>
                  {item.desc}
                </div>
              </TdsOverlay>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div
      className={clsx('tds-navigation', 'tds-navigation-light', className)}
      style={{
        position,
        backgroundColor: scroll || menuOpen ? '#fff' : 'transparent',
        boxShadow: scroll || menuOpen ? '0px 1px 4px 0px rgba(42, 58, 134, 0.15)' : 'none',
      }}
    >
      <div
        className="tds-navigation-content"
        style={{ width: typeof width === 'string' ? width : `${width}px` }}
      >
        <img
          src={TdsLogo}
          width={152}
          height={23}
          alt="TDS logo"
          className="tds-navigation-logo"
          onClick={() => window.open(homeUrl, '_self')}
        />
        {!isMobile ? (
          <div className='tds-navigation-row'>
            {PC_NAVIGATION.map((item) => {
              if (item.key === TdsItem.More && MORE_APPS.length) {
                return (
                  <TdsOverlay
                    component={moreMenu()}
                    overlayClassName={'tds-navigation-overlay'}
                    trigger={'hover'}
                    fixed={true}
                    onVisibleChange={visible => setMenuOpen(visible)}
                    key={item.key}
                    timeout={200}
                  >
                    <a
                      key={item.key}
                      className={clsx(
                        'tds-navigation-content-item',
                        item.key === activeMenu ? 'tds-navigation-content-item-active' : '',
                        'tds-navigation-content-item-more',
                      )}
                    >
                      {item.title}
                    </a>
                  </TdsOverlay>
                );
              }

              return (
                <a
                  key={item.key}
                  onClick={e => handleOpenUrl(e, NAVIGATION_URL[item.key][version][env], item.key)}
                  className={clsx(
                    'tds-navigation-content-item',
                    item.key === activeMenu ? 'tds-navigation-content-item-active' : '',
                  )}
                >
                  {item.title}
                </a>
              );
            })}
          </div>
        ) : (
          <TdsOverlay
            component={(
              <div className="tds-navigation-dropdown-container">
                {MOBILE_NAVIGATION.map(item => (
                  <a
                    className="tds-navigation-dropdown-item"
                    key={item.key}
                    onClick={e => handleOpenUrl(e, NAVIGATION_URL[item.key][version][env], item.key)}
                  >
                    <img src={item.icon} alt="" className="tds-navigation-dropdown-item-img" />
                    <div className="tds-navigation-dropdown-item-title">{item.title}</div>
                  </a>
                ))}
              </div>
            )}
            trigger={'click'}
            fixed={true}
            onVisibleChange={visible => setMenuOpen(visible)}
          >
            <div className="tds-navigation-menu-btn">
              <img src={MenuIcon} alt="menu" />
            </div>
          </TdsOverlay>
        )}
      </div>
    </div>
  );
};
